import { StorageKey } from "../constants/keys.constants";

export function SetStorageToken(token?: string) {

    if (!token) {
        localStorage.removeItem(StorageKey.SignInToken);
        return;
    }

    localStorage.setItem(StorageKey.SignInToken, token);
}

export function GetStorageToken() {
    return localStorage.getItem(StorageKey.SignInToken);
}

export function cn(...args: (string|boolean|undefined)[]) {
    return args.filter(v => v).join(" ");
}

export function isBlank(text: string) {
    return /^\s*$/.test(text);
}

export function isAnyBlank(...texts: string[]) {
    for (const txt of texts) {
        if (isBlank(txt)) return true;
    }

    return false;
}

export function join(...paths: string[]) {
    return paths.join("/").replace(/\\/g, '/').replace(/\/{2,}/g, '/');
}

export function passwordRegexTests(password: string) {
    const errs: string[] = [];

    if (isBlank(password)) errs.push("Cannot be blank");
    if (password.length < 8) errs.push("Must be at least 8 characters");
    if (!/[A-Z]/.test(password)) errs.push("Must contain at least 1 uppercase letter");
    if (!/[a-z]/.test(password)) errs.push("Must contain at least 1 lowercase letter");
    if (!/\d/.test(password)) errs.push("Must contain at least 1 number");
    if (!/[!@#$%^&*\-=_+]/.test(password)) errs.push("Must contain at least 1 symbol");

    return errs;
}

export function searchInArray(search: string, array: string[]) {
    for (const line of array) {
        if (line.toLowerCase().includes(search.toLowerCase())) return true;
    }

    return false;
}

export function clamp01(n: number) {
    return Math.max(0, Math.min(1, n));
}

export function round(n: number, pow = 2) {
    const exp = 10**pow;
    return Math.round(n * exp) / exp;
}